import {IQuoteWizardInputComponentStepTemplateProvider} from "./iquoteWizardInputComponentStepTemplateProvider";

export class NumberQuoteWizardStepTemplateProvider implements IQuoteWizardInputComponentStepTemplateProvider {
    constructor(
        public labelBinding: string,
        public modelBinding: string,
        public validationBinding?: string,
        public showDollarSign?: boolean
        ) {
    }

    public getTemplate(): string {
        return `<number-input
                label-binding="${this.labelBinding}"
                model-binding="${this.modelBinding}"
                validation-binding="${this.validationBinding || ''}"
                show-dollar-sign="${this.showDollarSign || false}"
                on-back-binding="vm.goBack()"
                on-next-binding="vm.goNext()">`;
    }
}
